import { ExtendedRoleRightService } from '../../services/extended-role-right.service';
import { ModuleType } from '@fi-shared/types/module-type';

export const FiRoleStateResolveExtendedRoleRoles = [
    'extendedRoleRight',
    ExtendedRoleRightService,
    FiRoleStateResolveExtendedRoleRoles_resolveFn,
];

export function FiRoleStateResolveExtendedRoleRoles_resolveFn(
    ExtendedRoleRight,
    extendedRoleRightService: ExtendedRoleRightService,
) {
    return extendedRoleRightService.GetLightWeightRoles(ExtendedRoleRight.BaseRoleId || 0, ModuleType.Core);
}
